<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="30%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="formRules" ref="formRules" label-width="80px">
      <el-form-item label="域名" prop="domain">
        <el-input v-model="formData.domain"></el-input>
      </el-form-item>
      <el-form-item v-if="id > 0" label="是否使用" prop="is_use">
        <el-select v-model="formData.is_use" placeholder="请选择是否使用" filterable>
          <el-option v-for="item in isUseList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="id > 0" label="状态" prop="status">
        <el-select v-model="formData.status" placeholder="请选择状态" filterable>
          <el-option v-for="item in statusList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'article_domain_add',
  props: [
    'visible', 'id', 'statusList', 'isUseList'
  ],
  data () {
    return {
      title: '添加文章域名',
      formData: {
        domain: '',
        is_use: 1,
        status: 1
      },
      formRules: {
        domain: [
          { required: true, message: '域名不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.formRules.resetFields()
      this.picUrl = ''
      this.$emit('close')
    },
    addConfirm () {
      this.$refs.formRules.validate(valid => {
        if (!valid) return
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑文章域名'
        this.getInfo(this.id)
      } else {
        this.title = '添加文章域名'
      }
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/article_domain/info/' + id)
      if (res.code === 0) {
        this.formData = {
          domain: res.data.domain,
          is_use: res.data.is_use,
          status: res.data.status
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
